var AppointmentsTabsDataTestId = /* @__PURE__ */ ((AppointmentsTabsDataTestId2) => {
  AppointmentsTabsDataTestId2["APPOINTMENTS_TABS"] = "appointments--tabs";
  AppointmentsTabsDataTestId2["APPOINTMENTS_TAB_TRIGGER_FUTURE"] = "appointments--tab-trigger-future";
  AppointmentsTabsDataTestId2["APPOINTMENTS_TAB_TRIGGER_PAST"] = "appointments--tab-trigger-past";
  AppointmentsTabsDataTestId2["APPOINTMENTS_TAB_TRIGGER_OTHER"] = "appointments--tab-trigger-other";
  AppointmentsTabsDataTestId2["APPOINTMENTS_TAB_CONTENT_FUTURE"] = "appointments--tab-content-future";
  AppointmentsTabsDataTestId2["APPOINTMENTS_TAB_CONTENT_PAST"] = "appointments--tab-content-past";
  AppointmentsTabsDataTestId2["APPOINTMENTS_TAB_CONTENT_OTHER"] = "appointments--tab-content-other";
  AppointmentsTabsDataTestId2["APPOINTMENTS_LOAD_MORE"] = "appointments--load-more";
  AppointmentsTabsDataTestId2["APPOINTMENTS_TITLE"] = "appointments--title";
  AppointmentsTabsDataTestId2["APPOINTMENT_DETAILS_TITLE"] = "appointment-details--title";
  AppointmentsTabsDataTestId2["APPOINTMENTS_OPTIONS_BUTTON"] = "appointments--options-button";
  AppointmentsTabsDataTestId2["APPOINTMENTS_EMPTY_STATE"] = "appointments--empty-state";
  AppointmentsTabsDataTestId2["APPOINTMENTS_EMPTY_STATE_BUTTON"] = "appointments--empty-state-button";
  return AppointmentsTabsDataTestId2;
})(AppointmentsTabsDataTestId || {});
export {
  AppointmentsTabsDataTestId
};
